module.exports = __webpack_public_path__ + "img/kj1.8ee18136.png";